import React from "react";
import { RadioCard, RadioCardProps } from "@/components/RadioCard";
import { useBundleContext } from "./BundleContext";
import { BundleTitle } from "./BundleTitle";
import { BundleDetails } from "./BundleDetails";
import { BundleIncentive } from "./BundleIncentive";

interface BundleCardProps extends Omit<RadioCardProps, "children"> {}

export const BundleCard = (props: BundleCardProps) => {
  const { bundle } = useBundleContext();
  return (
    <RadioCard
      header={
        bundle.banner ? (
          <p className="subtitle text-center font-semibold text-inherit">
            {bundle.banner}
          </p>
        ) : undefined
      }
      {...props}
    >
      <div className="-mr-8 space-y-4">
        <div className="space-y-2 pr-8">
          <BundleTitle />
          <BundleDetails />
        </div>
        <BundleIncentive />
      </div>
    </RadioCard>
  );
};
